<template>
	<div>
		<policy-submenu />

		<core-layout-content large>
			<!-- Headline -->
			<core-layout-headline-and-actions>
				<template slot="headline">{{ $t("commission_split") }}</template>
			</core-layout-headline-and-actions>

			<!-- Body -->
			<div class="xs-12">
				<!-- Mocked component for AEG -->
				<aeg-commission-split-and-summary
					v-if="['aeg', 'aeg_uat'].includes($store.state.tenantId)"
					:policyId="id"
				/>
				<!-- Mocked component for Aperion -->
				<apeiron-commissions
					v-if="['apeiron', 'apeiron_uat'].includes($store.state.tenantId)"
					:policyId="id"
				/>
				<!-- Other tenants -->
				<commission-split-and-summary v-else :policyId="id" />
			</div>
		</core-layout-content>
	</div>
</template>

<script>
import CrmIcon from "@/components/CrmIcon/"
import JButton from "@/components/JButton/"
import JCard from "@/components/JCard/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import PolicySubmenu from "../components/PolicySubmenu"
import CommissionSplitAndSummary from "../components/CommissionSplitAndSummary.vue"
import ApeironCommissions from "../components/mockedApeiron/ApeironCommissions"

export default {
	components: {
		CrmIcon,
		JButton,
		JCard,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		PolicySubmenu,
		CommissionSplitAndSummary,
		ApeironCommissions
	},

	props: {
		// From router
		id: String
	}
}
</script>
